import { z } from "zod";
import { BaseStatisticsOutputItemSchema } from "@/Schemas/Statistics/BaseStatisticsOutputItem";

export const StatisticsSourceOutputItemSchema = BaseStatisticsOutputItemSchema.extend({
    breakdown: z.record(z.string(), z.number()).nullable(),
});

export type StatisticsSourceOutputItem = z.infer<typeof StatisticsSourceOutputItemSchema>;

export const StatisticsSourceOutputSchema = z.object({
    items: z.array(StatisticsSourceOutputItemSchema),
});

export type StatisticsSourceOutput = z.infer<typeof StatisticsSourceOutputSchema>;